// extracted by mini-css-extract-plugin
module.exports = {"container":"routes_container__1iObs"};